import { Theme } from '@24i/nxg-sdk-photon';

export const getStyles = (theme: Theme) => ({
    buttonWrapper: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    space: {
        marginBottom: 32,
    },
    title: {
        color: theme.color.textPrimary,
        fontSize: 32,
    },
    message: {
        color: theme.color.textPrimary,
        opacity: 0.6,
    },
});
